<template>
    <base-tool
        :tool-name="tool.name"
        :tool-description="tool.description"
        @back="goBack"
    >
        <call-disposition-selector
            v-model="selectedCallDispositionId"
            data-testid="call-disposition-tool-selector"
            @change="handleCallDispositionChange"
        />
    </base-tool>
</template>

<script>
import { mapState } from 'vuex'
import CallDispositionSelector from '../../../call-disposition-selector'
import BaseTool from './base-tool.vue'
import ToolMixin from './tool-mixin'

export default {
    name: 'CallDispositionTool',

    mixins: [ToolMixin],

    components: {
        BaseTool,
        CallDispositionSelector
    },

    props: {
        tool: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            selectedCallDispositionId: null
        }
    },

    computed: {
        ...mapState(['call_dispositions'])
    },

    methods: {
        handleCallDispositionChange(id) {
            if (!id) {
                this.$emit('call-disposition-selected', null)
                return
            }

            const disposition = (this.call_dispositions || []).find(d => d.id === id)
            this.$emit('call-disposition-selected', disposition)
        }
    }
}
</script>

